import { useContext, useEffect } from 'react';
import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import CircleInfo from '../../assets/CircleInfo.svg';
import NotifyForm from '../../components/NotifyForm/NotifyForm';
import HeaderNavigation from '../../components/HeaderNavigation/HeaderNavigation';

import './Notify.scss';

function Notify() {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl } = state;

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);

    const handleBackArrow = () => {
        dispatch({ type: 'UPDATE_POPUP', payload: 'discard' })
    }

    return (
        <div className="FTTH__NotifyContainer">
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
            />
            <NotifyForm rtl={rtl} />
        </div>
    )
}

export default Notify